import data from "../../../../../src/LabelGroup.docs.json";
import * as React from 'react';
export default {
  data,
  React
};